import React from "react";

function HomeIcon({ className, fill }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5578 5.53423C12.6872 4.69887 11.3127 4.69887 10.4421 5.53423L5.81568 9.97357C5.70233 10.0823 5.62608 10.224 5.59774 10.3785C5.04361 13.4004 5.00271 16.494 5.47675 19.5295L5.58927 20.25H8.56573V14.0387C8.56573 13.6244 8.90152 13.2887 9.31573 13.2887H14.6842C15.0984 13.2887 15.4342 13.6244 15.4342 14.0387V20.25H18.4106L18.5231 19.5295C18.9972 16.494 18.9563 13.4004 18.4021 10.3785C18.3738 10.224 18.2976 10.0823 18.1842 9.97357L13.5578 5.53423ZM9.40357 4.45191C10.8545 3.05965 13.1454 3.05965 14.5963 4.45191L19.2227 8.89125C19.5633 9.21804 19.7924 9.64373 19.8775 10.108C20.4621 13.2956 20.5052 16.559 20.0052 19.7609L19.8244 20.9184C19.7496 21.3971 19.3374 21.75 18.8529 21.75H14.6842C14.2699 21.75 13.9342 21.4142 13.9342 21V14.7887H10.0657V21C10.0657 21.4142 9.72994 21.75 9.31573 21.75H5.147C4.66252 21.75 4.25023 21.3971 4.17548 20.9184L3.99472 19.7609C3.49467 16.559 3.53781 13.2956 4.12234 10.108C4.20748 9.64373 4.43656 9.21804 4.77713 8.89125L9.40357 4.45191Z"
      />
    </svg>
  );
}

export default HomeIcon;
